import React from 'react';


import './underline.css';

import { useState, useEffect  } from 'react';

function Underline(props) {

    
    const [anim, setAnim] = useState("");

    function toggleAnim(){
        console.log("toggleing animation")
        setTimeout( () => {
            setAnim("out--of--sight")
        }, 
       2900)
        
    }

    useEffect(() => 
        toggleAnim(), []
    )


    return (
      <div className="underline--container">
          {props.children}
          <div className="underline--glow">

          </div>
          <div className="underline--line">

          </div>
          <div className={"underline--blocker" + anim }>

          </div>
          <div className="underline--laser">

          </div>
      </div>
    );
  }
  
  export default Underline;
  